/**
 * Created with IntelliJ IDEA.
 * User: mozartdiniz
 * Date: 12/27/13
 * Time: 11:45 AM
 * To change this template use File | Settings | File Templates.
 */
import { DefaultRequest } from 'scripts/api';
import { actionCreators } from 'react/api/actions/survey';

const formatByCustomAttribute = (rule) => {
  let data = {};
  switch (rule.field.customAttr) {
    case 'Order.delivered':
      data.customAttr = rule.field.customAttr;
      data.attr = `Stop.orders.${rule.value.replace('actual', 'planned')}`;
      data.eq = `@order.${rule.value}@`;
      break;
    case 'Order.canceled':
      data.customAttr = rule.field.customAttr;
      data.attr = `Stop.orders.${rule.value}`;
      data.eq = 0;
      break;
    case 'Order.damaged':
      data.customAttr = rule.field.customAttr;
      data.attr = `Stop.orders.${rule.value}`;
      data.gt = 0;
      break;
    case 'Order.partialDelivery':
      data = [
        { customAttr: rule.field.customAttr, attr:`Stop.orders.${rule.value}`, gt: 0 },
        { attr:`Stop.orders.${rule.value}`, lt: `@order.${rule.value.replace('actual', 'planned')}@` }
      ];
    case 'Order.isNewOrder':
      data.customAttr = rule.field.customAttr;
      data.attr = rule.field.attr;
      data['eq'] = 1
      break;
    default:
      break;
  }
  return data;
};
Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.SurveyApplyRule = {
  data: [],
  applyRuleBuilded: false,
  triggerEvents: {
    ROUTE_START_ROUTE: 'Survey.Trigger.START_ROUTE',
    ROUTE_DEPART_ORIGIN: 'Survey.Trigger.DEPART_ORIGIN',
    ROUTE_ARRIVE_DESTINATION: 'Survey.Trigger.ARRIVE_DESTINATION',
    ROUTE_COMPLETE_ROUTE: 'Survey.Trigger.COMPLETE_ROUTE',
    ARRIVE_STOP: 'Survey.Trigger.ARRIVE_STOP',
    DEPART_STOP: 'Survey.Trigger.DEPART_STOP',
    CANCEL: 'Survey.Trigger.CANCEL',
    UNDELIVERABLE: 'Survey.Trigger.UNDELIVERABLE',
    REDELIVERY: 'Survey.Trigger.REDELIVEY',
    HOS_ON_DUTY: 'Survey.Trigger.START_DUTY',
    HOS_OFF_DUTY: 'Survey.Trigger.END_DUTY',
    HOS_START_BREAK: 'Survey.Trigger.START_BREAK',
    HOS_END_BREAK: 'Survey.Trigger.END_BREAK',
    HOS_START_LUNCH: 'Survey.Trigger.START_LUNCH',
    HOS_END_LUNCH: 'Survey.Trigger.END_LUNCH',
    HOS_START_DRIVE: 'Survey.Trigger.START_DRIVE',
    HOS_END_DRIVE: 'Survey.Trigger.END_DRIVE',
    HOS_START_SERVICE: 'Survey.Trigger.START_SERVICE',
    HOS_START_WAIT: 'Survey.Trigger.START_WAIT',
    HOS_END_WAIT: 'Survey.Trigger.END_WAIT',
    AT_TASKS_SCREEN: 'Survey.Trigger.AT_TASKS_SCREEN',
    AT_SURVEYS_SCREEN: 'Survey.Trigger.AT_SURVEYS_SCREEN',
    ORDER_DELIVERY: 'Survey.Trigger.ORDER_DELIVERY',
  },
  ruleTypeByTrigger: {
    ROUTE_START_ROUTE: 'route',
    ROUTE_DEPART_ORIGIN: 'route',
    ROUTE_ARRIVE_DESTINATION: 'route',
    ROUTE_COMPLETE_ROUTE: 'route',
    ARRIVE_STOP: 'stop',
    DEPART_STOP: 'stop',
    CANCEL: 'stop',
    UNDELIVERABLE: 'stop',
    REDELIVERY: 'stop',
    HOS_ON_DUTY: 'hos',
    HOS_OFF_DUTY: 'hos',
    HOS_START_BREAK: 'hos',
    HOS_END_BREAK: 'hos',
    HOS_START_LUNCH: 'hos',
    HOS_END_LUNCH: 'hos',
    HOS_START_DRIVE: 'hos',
    HOS_END_DRIVE: 'hos',
    HOS_START_SERVICE: 'hos',
    HOS_START_WAIT: 'hos',
    HOS_END_WAIT: 'hos',
    AT_TASKS_SCREEN: 'route',
    AT_SURVEYS_SCREEN: 'route',
    ORDER_DELIVERY: 'order'
  },
  operators: {
    eq: { value: 'eq', label: 'Survey.Operators.eq' },
    ne: { value: 'ne', label: 'Survey.Operators.ne' },
    lt: { value: 'lt', label: 'Survey.Operators.lt' },
    lte: { value: 'lte', label: 'Survey.Operators.lte' },
    gt: { value: 'gt', label: 'Survey.Operators.gt' },
    gte: { value: 'gte', label: 'Survey.Operators.gte' },
    in: { value: 'in', label: 'Survey.Operators.in' },
    yes: { value: 'yes', label: 'Yes' },
    no: { value: 'no', label: 'No' },
    notIn: { value: 'notIn', label: 'Survey.Operators.notIn' },
  },
  operatorsByFieldType: {
    text: ['eq', 'ne'],
    checkbox: ['yes', 'no'],
    lookup: ['eq', 'ne', 'in', 'notIn'],
    number: ['eq', 'ne', 'lt', 'gt', 'gte'],
  },
  fieldsWithCustomBehavior: [
    'Order.isNewOrder',
    'Order.delivered',
    'Order.canceled',
    'Order.damaged',
    'Order.partialDelivered'
  ],
  rules: [
    {
      label: 'Survey.ARules.Stop',
      ruletype: 'stop',
      fields: [
        {
          attr: 'Stop.stopType.id',
          label: 'Survey.ARules.Stop.stopType',
          type: 'lookup',
          entity: 'StopType',
          column: 'description',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.plannedSize1',
          label: 'Survey.ARules.Stop.plannedSize1',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.plannedSize2',
          label: 'Survey.ARules.Stop.plannedSize2',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.plannedSize3',
          label: 'Survey.ARules.Stop.plannedSize3',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.baseLineSize1',
          label: 'Survey.ARules.Stop.baseLineSize1',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.baseLineSize2',
          label: 'Survey.ARules.Stop.baseLineSize2',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.baseLineSize3',
          label: 'Survey.ARules.Stop.baseLineSize3',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.plannedPickupSize1',
          label: 'Survey.ARules.Stop.plannedPickupSize1',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.plannedPickupSize2',
          label: 'Survey.ARules.Stop.plannedPickupSize2',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.plannedPickupSize3',
          label: 'Survey.ARules.Stop.plannedPickupSize3',
          type: 'number',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Stop.orders.actualSize1',
          label: 'Survey.ARules.Stop.orders.actualSize1',
          type: 'number',
          ruleTypes: ['order'],
        },
      ],
    },
    {
      label: 'Survey.ARules.Location',
      ruletype: 'location',
      fields: [
        {
          attr: 'Location.key',
          label: 'Survey.ARules.Location.locationKey',
          type: 'lookup',
          entity: 'Location',
          column: 'key',
          ruleTypes: ['order'],
        },
        {
          attr: 'Location.locationType.id',
          label: 'Survey.ARules.Location.locationType',
          type: 'lookup',
          entity: 'LocationType',
          column: 'key',
          ruleTypes: ['stop', 'order'],
        },
        {
          attr: 'Location.accountType.id',
          label: 'Survey.ARules.Location.accountType',
          type: 'lookup',
          entity: 'AccountType',
          column: 'key',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Location.city',
          label: 'Survey.ARules.Location.city',
          type: 'text',
          column: 'description',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Location.state',
          label: 'Survey.ARules.Location.state',
          type: 'text',
          column: 'description',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Location.district',
          label: 'Survey.ARules.Location.district',
          type: 'text',
          column: 'description',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Location.country',
          label: 'Survey.ARules.Location.country',
          type: 'text',
          column: 'description',
          ruleTypes: ['stop'],
        },
        {
          attr: 'Location.deliveryInstructions',
          label: 'Survey.ARules.Location.deliveryInstructions',
          type: 'text',
          column: 'description',
          ruleTypes: ['order'],
        },
      ],
    },
    {
      label: 'Survey.ARules.Route',
      ruletype: 'route',
      fields: [
        {
          attr: 'Route.origin.id',
          label: 'Survey.ARules.Route.origin',
          type: 'lookup',
          entity: 'Location',
          column: 'description',
          ruleTypes: ['route'],
        },
        {
          attr: 'Route.destination.id',
          label: 'Survey.ARules.Route.destination',
          type: 'lookup',
          entity: 'Location',
          column: 'description',
          ruleTypes: ['route'],
        },
        {
          attr: 'Route.organization.id',
          label: 'Survey.ARules.Route.organization',
          type: 'lookup',
          entity: 'Organization',
          column: 'description',
          ruleTypes: ['route', 'order'],
        },
        {
          attr: 'Route.hasHelper',
          label: 'Survey.ARules.Route.hasHelper',
          type: 'checkbox',
          ruleTypes: ['route'],
        },
      ],
    },
    {
      label: 'Survey.ApplyRules.Driver',
      ruletype: 'driver',
      fields: [
        {
          attr: 'Driver.id',
          label: 'Survey.ARules.Driver',
          type: 'lookup',
          entity: 'Driver',
          column: 'name',
          ruleTypes: ['stop', 'route', 'hos'],
        },
      ],
    },
    {
      label: 'Survey.ApplyRules.Equipment',
      ruletype: 'equipment',
      fields: [
        {
          attr: 'Equipment.id',
          label: 'Survey.ARules.Equipment',
          type: 'lookup',
          entity: 'Equipment',
          column: 'description',
          ruleTypes: ['stop', 'route', 'hos'],
        },
      ],
    },
    {
      label: 'Survey.ARules.HOS',
      ruletype: 'hos',
      fields: [
        {
          attr: 'HoursOfService.hoursOfServiceType.id',
          label: 'Survey.ApplyRules.HOS.hosType',
          type: 'lookup',
          entity: 'HoursOfServiceType',
          column: 'description',
          ruleTypes: ['stop', 'route', 'hos'],
        },
      ],
    },
    {
      label: 'Survey.ARules.Order',
      ruletype: 'order',
      fields: [
        {
          attr: 'Stop.orders.newOrder',
          customAttr: 'Order.isNewOrder',
          label: 'Survey.ApplyRules.Order.isNewOrder',
          type: 'checkbox',
          entity: 'Order',
          column: 'isNew',
          ruleTypes: ['order'],
        },
        {
          customAttr: 'Order.delivered',
          label: 'Survey.ApplyRules.Order.delivered',
          ruleTypes: ['order'],
        },
        {
          customAttr: 'Order.canceled',
          label: 'Survey.ApplyRules.Order.canceled',
          ruleTypes: ['order'],
        },
        {
          customAttr: 'Order.damaged',
          label: 'Survey.ApplyRules.Order.damaged',
          ruleTypes: ['order'],
        },
        {
          customAttr: 'Order.partialDelivery',
          label: 'Survey.ApplyRules.Order.partialDelivery',
          ruleTypes: ['order'],
        },
      ],
    },
    {
      label: 'Survey.ARules.LineItem',
      ruletype: 'lineItem',
      fields: [
        {
          attr: 'Stop.orders.lineItems.sku.brand',
          label: 'Survey.ApplyRules.LineItem.sku.brand',
          type: 'text',
          entity: 'Sku',
          column: 'brand',
          ruleTypes: ['stop'],
        },
      ],
    },
    {
      label: 'Survey.ApplyRules.UndeliverableCode',
      ruletype: 'stop',
      fields: [
          {
          attr: 'UndeliverableCode.id',
          label: 'Survey.ARules.UndeliverableCode',
          type: 'lookup',
          entity: 'UndeliverableCode',
          column: 'description',
          ruleTypes: ['stop'],
          },
      ],
      triggersToShow: ['UNDELIVERABLE', 'REDELIVERY']
    }
  ],

  clearApplyRuleData: function () {
    this.data = [];
    this.applyRuleBuilded = false;
  },
  renderRulesList: function () {
    const applyRulesContainer = document.getElementById('SurveyApplyRulesRulesListContainer');
    const fragment = document.createDocumentFragment();
    if (this.data.length) {
      for (var item = 0, l = this.data.length; item < l; item++) {
        fragment.appendChild(this.createRuleListItem(this.data[item], item));
      }
    }
    applyRulesContainer.innerHTML = '';
    applyRulesContainer.appendChild(fragment);
  },

  deleteRule: function (ruleIndex, scope) {

    var data = scope.data[ruleIndex];

    scope.data.splice(ruleIndex, 1);
    scope.renderRulesList();

    if (data.isNew !== true) {

        const request = new DefaultRequest({
            url: 'SurveyApplyRule/' + data.id,
            method: 'delete'
        });
        request.send();

    }

},

  createRuleListItem: function (data, itemIndex) {
    var ruleItemContainer = document.createElement('div');
    var whenLabel = document.createElement('div');
    var trashIcon = document.createElement('div');
    var triggerEvent = this.triggerEvents[data.surveyType] || this.triggerEvents[data.when.value];
    var hasReleasedDate = Greenmile.Survey.Builder.releasedDate;

    whenLabel.className = 'SurveyRulesListItemWhen';
    trashIcon.className = 'SurveyRulesListItemTrash';
    ruleItemContainer.className = 'SurveyRulesListItemContainer';
    whenLabel.innerHTML = Monet.I18n.getResourcesByKey(triggerEvent);

    whenLabel.addEventListener(
      'click',
      function () {

      GreenmileReduxStore.dispatch(
          actionCreators.openApplicationRulesModal({ ruleData: data }));

      }
    );
    const deleteRule = () => {
      const data = this.data[itemIndex];
      this.data.splice(itemIndex, 1);
      this.renderRulesList();

      if (!data.isNew) {
        const request = new DefaultRequest({
            url: 'SurveyApplyRule/' + data.id,
            method: 'delete'
        });
        request.send();
      }
    };

    trashIcon.addEventListener(
      'click',
      deleteRule.bind(this),
    );

    if (hasReleasedDate) {
      trashIcon.style.display = 'none';
      whenLabel.className = 'DisabledSurveyRulesListItemWhen';
    }

    ruleItemContainer.appendChild(whenLabel);
    ruleItemContainer.appendChild(trashIcon);

    return ruleItemContainer;
  },
  prepareDataToSend: function() {
    Greenmile.Survey.SurveyApplyRule.applyRuleBuilded = true;

    return this.data.map(applyRule => {
      const newRule = {
        surveyType: applyRule.when.value
      };
      if (!applyRule.isNew) {
        newRule.id = applyRule.id;
      }
      const rules = [];
      applyRule.rules.forEach(rule => {
        const ruleFieldType = rule.field.type;
        const ruleFieldColumn = rule.field.column;
        const ruleFieldAttr = rule.field.attr;
        let data = {}
        const setDataRuleOperator = value => { data[rule.operator] = value };
        const setDataRuleFieldColumn = value => { data[ruleFieldColumn] = value };

        data.attr = ruleFieldAttr;
        if (rule.field.customAttr) {
          data = formatByCustomAttribute(rule);
        } else if (ruleFieldType === 'lookup') {

          if (Array.isArray(rule.value)) {
            const listOfValues = rule.value.map(data => data?.id ? data.id.toString() : data);
            setDataRuleOperator(listOfValues);
          } else {
            
            if (ruleFieldAttr.includes('key') && ruleFieldColumn === 'key') {
              data.id = rule.value.id;
              setDataRuleOperator(rule.value[ruleFieldColumn]);
            } else {
              setDataRuleOperator(rule.value.id);
              const ruleValue = rule.value[ruleFieldColumn] || rule.value.description;
              setDataRuleFieldColumn(ruleValue);
            }
          }

        } else if (ruleFieldType === 'checkbox') {
          setDataRuleOperator(false);
        } else {
          setDataRuleOperator(rule.value);
        }
        if (data.length) {
          rules.push(...data);
        } else {
          rules.push(data);
        }
      });
      newRule.jsonRule = JSON.stringify(rules);
      return newRule;
    });
  }
};
